
  function remove_item(id) {
      document.getElementById('updates_'+id).value = 0;
      document.getElementById('cartform').submit();
  }
        $(document).ready(function (){        
        // if cart contains insurance, hide tickbox
        Shopify.getCart(function(data){
            var skus = new Array();
            $.each(data.items, function(index, value) {skus.push(value.variant_id); })
           if(skus.indexOf(cover_sku) != -1){
               $('.addcoverspan').hide();
            }
        });
        });    // end ready
